import PredictiveSignalsPanel from './PredictiveSignalsPanel'

type CoachInterventionsCardProps = {
  onEvaluated?: (status: string) => void
}

const CoachInterventionsCard = ({ onEvaluated }: CoachInterventionsCardProps) => (
  <PredictiveSignalsPanel onEvaluated={onEvaluated} grouped />
)

export default CoachInterventionsCard
